



























































import { computed, defineComponent } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import Store from "@/store";
import { MUTATION_TYPES } from "@/store/const";
import { ProfileFileType } from "@/const";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseInputFile from "@/components/BaseInputFile";
import AvatarCropModal from "./components/AvatarCropModal.vue";
import useProfileFileController from "../hooks/useProfileFileController";

export default defineComponent({
  name: "UserAvatarController",
  components: { AvatarCropModal, BaseButton, BaseInputFile, BaseAvatar },
  props: {
    user: { type: Object as () => User | UserWithAvatar, required: true },
    nsfw: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { authUserStrict } = useAuthUser();

    const fieldName = computed(() => (props.nsfw ? "avatarNsfw" : "avatar"));
    const hasFile = computed(() => !!props.user[fieldName.value]);

    const updateUser = (file: FileData | null) => {
      if (props.user.id !== authUserStrict.value.id) return;
      Store.commit(MUTATION_TYPES.SET_USER, {
        ...authUserStrict.value,
        [fieldName.value]: file,
      });
    };

    const {
      newSrc,
      showCropModal,
      loading,
      deleting,
      onUploadClick,
      onCropClose,
      onCropped,
      onDelete,
    } = useProfileFileController({
      getUserId: () => props.user.id,
      getType: () => (props.nsfw ? ProfileFileType.AVATAR_NSFW : ProfileFileType.AVATAR),
      onUploaded: file => {
        updateUser(file);
        emit("update", file);
      },
      onDeleted: () => {
        updateUser(null);
        emit("update", null);
      },
    });

    return {
      loading,
      showCropModal,
      newSrc,
      hasFile,
      deleting,
      onDelete,
      onCropClose,
      onUploadClick,
      onCropped,
    };
  },
});
